import React, { Component } from 'react';
import '../../css/style.css';
import { Grid, Breadcrumb, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
class BreadcrumbCustom extends Component {

    render() {
        return (
            <Grid className="padding-bch bredcrumpzIndex" >
                <Grid.Column width={7}>
                    <Breadcrumb className="mini">
                       {!this.props.clientId && <Breadcrumb.Section as={Link} to={"/home"}>{this.props.t("home")}&nbsp;&nbsp;</Breadcrumb.Section> }
                        {
                            (() => {
                                if (this.props.parent) {
                                    return (
                                        <span>
                                            <Breadcrumb.Divider />
                                            <Breadcrumb.Section>{this.props.parent}&nbsp;</Breadcrumb.Section>
                                        </span>
                                    )
                                }
                            }
                            )()}
                        {
                            (() => {
                                return this.props.child.map((item, index) => {
                                    if (item.url) {
                                        return (
                                            <span key={index}>
                                                <Breadcrumb.Divider />
                                                <Breadcrumb.Section as={Link} to={item.url}>{item.name}&nbsp;</Breadcrumb.Section>
                                            </span>
                                        )
                                    } else {
                                        return (
                                            <span key={index}>
                                                <Breadcrumb.Divider ><Icon className="right arrow" /></Breadcrumb.Divider>
                                                <Breadcrumb.Section >{item.name}&nbsp;</Breadcrumb.Section>
                                            </span>
                                        )
                                    }

                                })
                            }
                            )()}
                    </Breadcrumb>
                </Grid.Column>
                <Grid.Column width={1}>
                </Grid.Column>
            </Grid>
        );
    }
}
export default BreadcrumbCustom;


// WEBPACK FOOTER //
// ./src/app/layout/BreadcrumbCustom.js